import {IAppEvent} from "./events/app-event";
import {APINamespace, callApi, CallMethod} from "../../../common/api";

export async function publishEvent(event: IAppEvent) {
  await callApi(CallMethod.post, "events", {
    data: event,
    apiNamespace: APINamespace.app
  });
}
